/**
 * Singleton registry of "before-leave" guards. Used by destructive flows
 * (logout, app navigation, beforeunload) to check if any context — currently
 * just Manage drafts — wants to interrupt with a confirm dialog.
 *
 * A guard returns `true` when the action is safe to proceed and `false` when
 * the user aborted. Guards run sequentially so each can present its own
 * dialog; the first abort short-circuits.
 */

type DraftGuard = () => Promise<boolean>

const guards = new Set<DraftGuard>()

export const registerDraftGuard = (guard: DraftGuard): (() => void) => {
  guards.add(guard)
  return () => {
    guards.delete(guard)
  }
}

export const runDraftGuards = async (): Promise<boolean> => {
  for (const guard of Array.from(guards)) {
    const proceed = await guard()
    if (!proceed) return false
  }
  return true
}
